module.exports = __webpack_public_path__ + "media/react/features/event-creation-wizard/assets/templates/webinar-6a4efb0e86ef06e800cbdafc1d623498.png";